import { useQuery } from '@tanstack/react-query';
import { Encounter } from 'src/models';
import { ambientApi } from 'src/services';
import { UseQueryOverrideOptions } from '../common';

export type UseGetEncounterByEhrAppointmentIdParams = {
  ehrAppointmentId: string;
};

export type GetEncounterByEhrAppointmentIdResponse = Encounter;

export const getEncounterByEhrAppointmentId = async (
  ehrAppointmentId: string
): Promise<Encounter> => {
  const response = await ambientApi.get<Encounter>(
    `/encounters/appointments/ehr/${ehrAppointmentId}/`
  );
  return response.data;
};

export const useGetEncounterByEhrAppointmentId = (
  { ehrAppointmentId }: UseGetEncounterByEhrAppointmentIdParams,
  options: UseQueryOverrideOptions<GetEncounterByEhrAppointmentIdResponse> = {}
) => {
  return useQuery({
    ...options,
    queryKey: ['encounterByEhrAppointmentId', ehrAppointmentId],
    queryFn: () => getEncounterByEhrAppointmentId(ehrAppointmentId),
  });
};
